/**
 * Quellen-Snippet-Cleaner für die Frontend-Anzeige.
 *
 * Backend persistiert die rohen Chunk-Inhalte aus pymupdf4llm — die enthalten:
 *  - U+FFFD-Replacement-Chars (verlorene Bytes bei polnischen/exotischen
 *    Sonderzeichen), die wie Müllblöcke aussehen.
 *  - Bild-Marker-Noise: `==> picture [N x M] intentionally omitted <==`
 *    und `----- Start/End of picture text -----` Pseudo-Trennlinien.
 *  - PDF-Page-Header-Boilerplate ("CONFIDENTIAL ... Page X of Y") die
 *    auf jeder Seite wiederholt wird und im Chunk keinen Mehrwert hat.
 *  - `<br>`-Spam und 3+ Leerzeilen.
 *
 * Die Originale in der DB sind weiterhin „dirty" — dieses Cleanup macht das
 * nur für die Anzeige im Quellen-Pane. Für eine permanente Bereinigung
 * müssten die Documents re-ingestiert werden (ftfy + clean_pymupdf_markdown
 * laufen seit Phase 9.5 standardmäßig im Pipeline).
 */

const FFFD_RUN_RE = /�+/g;
const PICTURE_OMITTED_RE =
  /\*{0,2}={1,3}>\s*picture\s*\[[^\]]*\]\s*intentionally\s*omitted\s*<{1,3}=\*{0,2}/gi;
const PIC_TEXT_MARKER_RE =
  /(?:\*{0,2})-{3,}\s*(?:Start|End)\s+of\s+picture\s+text\s*-{3,}(?:\*{0,2})/gi;
const BR_SPAM_RE = /(?:\s*<br\s*\/?>\s*){2,}/gi;
const TRIPLE_NL_RE = /\n{3,}/g;
// Klassischer CER-Page-Header (variabler Doc-Title möglich, aber das
// „Page X of Y" am Ende ist verlässlich genug als Anker).
const PAGE_HEADER_RE =
  /(?:CONFIDENTIAL\s+)?[^\n]{0,80}Page\s+\d+\s+of\s+\d+\s*\n?/gi;

export function cleanSnippet(text: string | null | undefined): string {
  if (!text) return "";
  let out = text;
  out = out.replace(FFFD_RUN_RE, "…");
  out = out.replace(PICTURE_OMITTED_RE, "");
  out = out.replace(PIC_TEXT_MARKER_RE, "");
  out = out.replace(PAGE_HEADER_RE, "");
  out = out.replace(BR_SPAM_RE, "\n");
  out = out.replace(/<br\s*\/?>/gi, "\n");
  out = out.replace(TRIPLE_NL_RE, "\n\n");
  return out.trim();
}
